<template>
  <Layout>
    <template #content>
      <div class="mainContent">
        <pageHead device="desktop" page="sport" :title="Title" :description="$t('store.sport_description')"/>
        <div class="game-wrap pcsport">
          <h1 class="title"><span class="bg">{{ Title }}</span><q class="dn fg">{{ Title }}</q></h1>
          <div class="game-list one-piece sport">
            <template v-for="(item, index) in Product(ProductId)">
              <gameMod
                v-model="item.Id"
                :productId="ProductId"
                :className="`game-group product_${item.Id} ${item.Maintain}`"
                :data-text="$t('store.uphold_ing')"
                :langPlayGame="LangPlayGame"
              />
            </template>
          </div>
        </div>
      </div>
    </template> 
  </Layout>
</template>
<script>
  const Layout = require(`~/components/desktop/layouts/${process.env.DEF_webFrame}.vue`).default;
  import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
  import pageHead from "~/components/common/pageHead.vue";
  import gameMod from "~/components/desktop/gameMod.vue";
  export default {
    components: {
      Layout,
      pageHead,
      gameMod,
    },
    data() {
      return {
        description: this.$t("store.sport_description"),
        ProductId: 1,
      };
    },
    methods: {
      changeLang() {
        this.description = this.$t("store.sport_description");
      },
    },
    mounted: function () {
      this.changeLang();
    },
    watch: {
      "$i18n.locale"(language) {
        this.changeLang();
      },
    },
    computed: {
      HasX() {
        return Object.keys(this.$route.query).indexOf('x') >= 0;
      },
      Title() {
        if (this.HasX)
          return '運彩賽事' + (this.ShowPageWebSeoName ? ` - ${this.WebSeoName}` : '');
        else
          return this.$t("store.game_sport") + (this.ShowPageWebSeoName ? ` - ${this.WebSeoName}` : '');
      },
      LangPlayGame() {
        if (this.HasX)
          return '運彩線上投注';
        else
          return this.$t("store.btn.play_game_now");
      },
      ...mapGetters(["Product", "WebSeoName", "ShowPageWebSeoName"])
    },
  };
</script>

<style scoped></style>
